const validatePasswordLength = (str) => {
  const isInvalidLength = str.length < 6;
  return isInvalidLength;
};

export default validatePasswordLength;
